import {ActionPropsHolder} from './actionProps';

export type onShowDeleted = () => void;

export function showDeleted(
  holder: ActionPropsHolder,
  onShowDeleted?: onShowDeleted,
) {
  if (onShowDeleted) {
    onShowDeleted();
  }
}
